import styled, { css } from 'styled-components'

interface ContainerProps {
    containerBackgroundColor?: string
    containerBorderRadius?: string
    containerWidth?: string
    containerHeight?: string
    containerMargin?: string
    containerPadding?: string
    containerborderColor?: string
}

export const Container = styled.div<ContainerProps>(
    ({
        containerBackgroundColor,
        containerBorderRadius,
        containerHeight,
        containerWidth,
        containerMargin,
        containerPadding,
        theme,
        containerborderColor,
    }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${theme.layout.xSmall};
        height: ${theme.layout.xSmall};
        background: ${theme.colors.white};
        padding: ${theme.spacing.xxSmall};
        margin: ${theme.spacing.small};
        border-radius: ${theme.typography.border.radius.xLarge};
        box-shadow: 0px 4.31px 4.31px 0px #00000014, 0px 2.59px 12.08px 0px #0000000a, 0px 6.9px 8.63px 0px #0000000f;
        ${!!containerborderColor &&
        css`
            border: 1px solid ${containerborderColor};
        `};
        ${!!containerBackgroundColor &&
        css`
            background-color: ${containerBackgroundColor};
        `};
        ${!!containerBorderRadius &&
        css`
            border-radius: ${containerBorderRadius};
        `};
        ${!!containerHeight &&
        css`
            height: ${containerHeight};
        `};
        ${!!containerWidth &&
        css`
            width: ${containerWidth};
        `};
        ${!!containerMargin &&
        css`
            margin: ${containerMargin};
        `};
        ${!!containerPadding &&
        css`
            padding: ${containerPadding};
        `};
    `,
)

interface WishlistIconProps {
    width?: string
    height?: string
}

export const WishlistIcon = styled.img<WishlistIconProps>(
    ({ width, height, theme }) => css`
        width: ${theme.layout.xxSmall};
        height: ${theme.layout.xxSmall};
        ${!!width &&
        css`
            height: ${width};
        `};
        ${!!height &&
        css`
            width: ${height};
        `};
    `,
)
